import React from "react";

// TODO: Improve handling of colors in svg icons
interface Props {
  color?: "#fd6a65" | "black";
}

export const CloseIcon: React.FC<React.PropsWithChildren<Props>> = ({
  color = "black",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path
          d="M9.228 9.228a.778.778 0 0 1 1.1 0L16 14.9l5.672-5.672a.778.778 0 1 1 1.1 1.1L17.1 16l5.672 5.672a.778.778 0 1 1-1.1 1.1L16 17.1l-5.672 5.672a.778.778 0 0 1-1.1-1.1L14.9 16l-5.672-5.672a.778.778 0 0 1 0-1.1Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
